/**
 * https://webpack.js.org/guides/public-path/
 * Specify the base path where chunks should be referenced
 * PROD: Our CDN (test, stage, prod)
 * LOCAL: Webpack-dev-servers in memory file path - http://localhost:8081
 * LOCAL w/ WP prod config: Build foler - http://localhost:8080/static
 * */
__webpack_public_path__ = `${window.cdnUrl}/`; // eslint-disable-line no-undef, camelcase
